import React from 'react';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import TrustedBy from '../components/TrustedBy';
import CTA from '../components/CTA';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <ServicesSection />
      <TrustedBy />
      <CTA />
    </div>
  );
};

export default Home;
